import { REQUIRED_CARD_PROPS } from '@yme/components/WhatToReadNext/constants';
import { getFormattedDate, prepareDateRangeText } from '@yme/utils/common';
export function isWhatToReadNextEmpty(props) {
    return !props || !props.cards?.length;
}
export function isWhatToReadNextCardEmpty(card) {
    return REQUIRED_CARD_PROPS.some((key) => !card[key]);
}
export function prepareCaption(date, dateFrom, dateTo, lang = 'en-US') {
    if (date) {
        return getFormattedDate({
            date,
            lang,
        });
    }
    if (dateFrom && dateTo) {
        return prepareDateRangeText({
            dateFrom,
            dateTo,
            lang,
            hasTime: false,
        });
    }
    return '';
}
